import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/storage'
import { Message, MessageBox } from 'element-ui'
import router from '../router'
import { toLogin } from '@/utils/toLogin'
import { DialogInterface } from '@/utils/dialogInterface'
import errorDialog from '@/components/errorDialog'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  timeout: 120000// request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['X-token'] = getToken()
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data
    if (response.status === 401 || res.code === '208') {
      MessageBox.confirm(
        '你已被登出，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {
          // router.push('/login')
          toLogin()
        })
      })
      return
    }
    if (
      res.code === '204' ||
      res.code === '202' ||
      res.code === '206' ||
      res.code === '210'
    ) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res.msg)
    }
    if (response.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      return response
    }
  },
  error => {
    if (
      error.config.url !== '/personal/employee/employeeInfo' &&
      error.config.url.indexOf('/bpm-server/bpm-client/task/formData') === -1
    ) {
      new DialogInterface().open(
        errorDialog,
        { response: error },
        {
          title: '错误信息',
          type: 'error'
        }
      )
    }

    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(res.msg)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js